import { Spin } from 'antd';
import React from 'react';
import './Spinner.scss';

const Spinner = () => (
    <div className='spinner'>
            <Spin tip="Loading..." >
            </Spin>
    </div>
);

export default Spinner;